<template>
	<ui-form :model="model" :transfer-model.sync="submitData" :columns="1" v-slot="{data}">
		<ui-text v-model="data.count" label="用户名" view/>
		<ui-text v-model="data.oldPassword" label="原密码" show-password required/>
		<ui-text v-model="data.password" label="新密码" show-password required/>
		<ui-text v-model="data.passwordConfirm" label="确认密码" show-password required nosubmit/>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{},
			model:{
				id:this.params.data.id,
				count:'',
				oldPassword:'',
				password:'',
				passwordConfirm:''

			}
		};
	},
	mounted() {
		this.$axios.get('/admin/sys/info/'+this.params.data.id).then(data=>{
			console.log(data)
			this.model.count = data.count;
		}).end();
	},
	methods:{
		submit(){
			if(this.params.data.password!=this.params.data.passwordConfirm){
				this.$msgbox('两次密码必须相同！');
				return;
			}
			this.$axios.request({url:'/password/'+this.params.data.id,data:this.submitData,method:'post',urlencode:true})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
